goog.provide("shadow.js.shim.module$src$svg$wpp$arrows$trend_ascent_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$arrows$trend_ascent_svg");
shadow.js.shim.module$src$svg$wpp$arrows$trend_ascent_svg = shadow.js.nativeProvides["src/svg/wpp/arrows/trend-ascent.svg"] = shadow$bridge("src/svg/wpp/arrows/trend-ascent.svg");
module$shadow_js_shim_module$src$svg$wpp$arrows$trend_ascent_svg.default = shadow.js.shim.module$src$svg$wpp$arrows$trend_ascent_svg;
